import { daysOfWeek, monthNames } from '@config/ngx-daterangepicker.config';
import * as moment from 'moment';

moment.locale('es-mx');

export const DatePickerLocale: any = {
  displayFormat: 'MM/DD/YYYY',
  daysOfWeek,
  monthNames,
};

export const DatePickerMaxDate: any = new Date(
  new Date().getFullYear(),
  new Date().getMonth() + 1,
  0
).getDate();
